import React from 'react';
import './FeaturedVideo.scss';

const FeaturedVideo = ({ kicker, sub, featured, onOpenContent }) => {
if (!featured) return null;

return (
    <div className="FeaturedVideo">
        <div className="hub-featured">
        <div className="hub-featured-head">
            <div className="hub-kicker">{kicker}</div>
            <div className="hub-sub">{sub}</div>
        </div>

        <button 
            className="featured-card" 
            type="button" 
            onClick={() => onOpenContent(featured)}
        >
            <div className="thumb featured-thumb">
            <img src={featured.thumb} alt={featured.title} />
            </div>

            <div className="meta">
                {/* <div className="card-title">{featured.title}</div> */}
                <div className="card-desc">{featured.desc}</div>
            </div>
        </button>
        </div>
    </div>
);
};

export default FeaturedVideo;